import { inject } from '@angular/core';
import { ENVIRONMENT } from '@vasta/env';

/**
 * Whether a request is one of ours — a call to the API the environment names,
 * as opposed to Zitadel or anything else the page talks to.
 *
 * The headers below only our API understands must not ride on the rest. A
 * cross-origin call carrying a header the other side does not know is
 * preflighted first, and Zitadel refuses those, which leaves the tab unable to
 * log in at all. `Authorization` is the exception, and only because Zitadel
 * allows it — see `authInterceptor`.
 *
 * Call it from an injection context; an interceptor's own body is one.
 */
export function isApiRequest(request: { url: string }): boolean {
  return request.url.startsWith(inject(ENVIRONMENT).apiBaseUrl);
}
